<div class="messages-list">
  <ng-container *ngIf="!!messages; else tmpLoading">
    <ng-container *ngIf="messages.length; else tmpNoData">
      <div *ngFor="let message of messages" class="messages-list-group">
        <message-custom *ngIf="message.id === firstIncomingUnreadMessageId">
          {{ 'components.messagesList.labels.unreadMessages' | translate }}
        </message-custom>

        <message-custom *ngIf="groupData[message.id] as date">
          {{ date }}
        </message-custom>

        <message-wrapper
          #dropdown="tuiDropdown"
          #intObserverReading="IntersectionObserver"
          [id]="message.id"
          waIntersectionObserver
          waIntersectionThreshold="1"
          (waIntersectionObservee)="onIntersection($event, message, intObserverReading)"
          tuiDropdownContext
          class="messages-list-item"
          [message]="message"
          [permissions]="permissions"
          [tuiDropdown]="contextMenu"
        >
          <ng-container [ngSwitch]="message.contentType">
            <ng-container *ngSwitchCase="MessageContentTypeEnum.Text">
              <message-text [message]="message"></message-text>
            </ng-container>

            <ng-container *ngSwitchCase="MessageContentTypeEnum.File">
              <message-file [message]="message"></message-file>
            </ng-container>

            <ng-container *ngSwitchCase="MessageContentTypeEnum.Image">
              <message-image [message]="message"></message-image>
            </ng-container>

            <ng-container *ngSwitchCase="MessageContentTypeEnum.Emodji">emodji</ng-container>

            <ng-container *ngSwitchDefault>
              {{ 'components.internalMessenger.labels.unsupportedMessageType' | translate }}
            </ng-container>
          </ng-container>

          <ng-template #contextMenu>
            <app-reaction-selection
              *ngIf="!!permissions?.canSendReactions"
              (reactionClicked)="sendReaction($event, message); dropdown.toggle(false)"
            ></app-reaction-selection>

            <app-actions
              [mode]="'data-list'"
              [items]="contextMenuActions"
              [object]="message"
              (clicked)="dropdown.toggle(false)"
            ></app-actions>
          </ng-template>
        </message-wrapper>
      </div>
    </ng-container>
  </ng-container>
</div>

<ng-template #tmpLoading>
  <app-skeleton-wrapper [loading]="true"></app-skeleton-wrapper>
</ng-template>

<ng-template #tmpNoData>
  <div class="no-data">
    <p>{{ 'components.internalMessenger.labels.noMessages' | translate }}</p>
  </div>
</ng-template>
